export default "__VITE_ASSET__CcLusf8G__"